
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[number]",
      function () {
        return require("private-next-pages/blog/page/[number]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/page/[number]"])
      });
    }
  